var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcCheckCircleFill = function SvgIcCheckCircleFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2m4.268 6.92a1 1 0 0 0-1.415 0l-4.038 4.039-1.668-1.666a1 1 0 0 0-1.414 1.414l2.374 2.373a1 1 0 0 0 1.415 0l4.746-4.746a1 1 0 0 0 0-1.414"
  })));
};
export default SvgIcCheckCircleFill;